/**
 * MealsPage — Page standalone du module Repas (accessible via sidebar).
 * Réutilise le composant MealsTab qui contient tout le dashboard.
 */
import React from 'react';
import MealsTab from '../components/creche/MealsTab';

export default function MealsPage({ showAllStructures = false }) {
  return (
    <div className="min-h-full bg-gray-50">
      <MealsTab showAllStructures={showAllStructures} />
    </div>
  );
}
